<template>
  <div>
    <v-card
        height="100%"
        width="100%"
        class="d-flex flex-column rounded-lg"
        flat
    >
      <div class="d-flex justify-space-between align-center">
        <v-card-title class="text-break link-on-hover" @click.prevent="navigate('/connections/bio-age')"><strong>{{ $t('cards.titles.yourAchievements') }} ></strong></v-card-title>
        <v-btn
            outlined
            icon
            x-small
            color="primary"
            class="mx-4"
            @click.prevent="showDisclaimerDialog = true"
        >
          <v-icon x-small>fal fa-info</v-icon>
        </v-btn>
      </div>
      <!--<v-card-title class="text-break"><strong>{{ $t('cards.titles.yourAchievements') }}</strong></v-card-title>-->
      <v-card-text v-if="isLoading" class="d-flex justify-center">
        <v-progress-circular
            color="primary"
            indeterminate
            size="64"
        ></v-progress-circular>
      </v-card-text>
      
      <v-card-text v-if="!isLoading" class="pa-0">
        <div v-if="!connectionWefitter.wefitterBioAgeConnected && !connectionWefitterLoading" class="col-12 px-4 py-0">
          <div v-html="$t('weFitter.bioAgeNotConnected')"></div>
        </div>
        <div class="d-flex flex-wrap justify-space-between">
          <div class="col-12 col-sm-6 col-md-4 col-lg-3 ma-0 d-flex flex-nowrap justify-start align-center pa-4">
            <div class="mr-4">
              <v-sheet
                width="80"
                height="80"
                min-height="80"
                min-width="80"
                color="primary lighten-2"
                class="d-flex justify-center align-center rounded-lg"
              >
                <v-icon color="primary" size="40">fal fa-calendar-days</v-icon>
              </v-sheet>
            </div>
            <div class="ml-4">
              <div class="text-break text-h6 font-weight-black">{{ $t('labels.bio-age') }}</div>
              <div class="primary--text text-h5 font-weight-black">{{ bioAgeList.length ? Math.round(bioAgeList[0]["bio_age"]) : '-' }}</div>
            </div>
          </div>
          
          <div class="col-12 col-sm-6 col-md-4 col-lg-3 ma-0 d-flex flex-nowrap justify-start align-center pa-4">
            <div class="mr-4">
              <v-sheet
                width="80"
                height="80"
                min-height="80"
                min-width="80"
                color="secondary lighten-2"
                class="d-flex justify-center align-center rounded-lg"
              >
                <v-icon color="secondary" size="40">fal fa-shoe-prints</v-icon>
              </v-sheet>
            </div>
            <div class="ml-4">
              <div class="text-break text-h6 font-weight-black">{{ $t('labels.params.steps') }}</div>
              <div class="secondary--text text-h5 font-weight-black">{{ dailySummary.length && dailySummary[0].steps > 0 ? dailySummary[0].steps : '-' }}</div>
            </div>
          </div>
          
          <div class="col-12 col-sm-6 col-md-4 col-lg-3 ma-0 d-flex flex-nowrap justify-start align-center pa-4">
            <div class="mr-4">
              <v-sheet
                  width="80"
                  height="80"
                  min-height="80"
                  min-width="80"
                  color="accent lighten-2"
                  class="d-flex justify-center align-center rounded-lg"
              >
                <v-icon color="accent" size="40">fal fa-location-dot</v-icon>
              </v-sheet>
            </div>
            <div class="ml-4">
              <div class="text-break text-h6 font-weight-black">{{ $t('labels.params.distance') }}</div>
              <div class="accent--text text-h5 font-weight-black">{{ dailySummary.length && dailySummary[0].distance > 0 ? Math.round(dailySummary[0].distance) : '-' }} m</div>
            </div>
          </div>
          
          <div class="col-12 col-sm-6 col-md-4 col-lg-3 ma-0 d-flex flex-nowrap justify-start align-center pa-4">
            <div class="mr-4">
              <v-sheet
                  width="80"
                  height="80"
                  min-height="80"
                  min-width="80"
                  color="info lighten-2"
                  class="d-flex justify-center align-center rounded-lg"
              >
                <v-icon color="info" size="40">fal fa-fire-flame</v-icon>
              </v-sheet>
            </div>
            <div class="ml-4">
              <div class="text-break text-h6 font-weight-black">{{ $t('labels.params.calories') }}</div>
              <div class="info--text text-h5 font-weight-black">{{ dailySummary.length && dailySummary[0].calories > 0 ? Math.round(dailySummary[0].calories) : '-' }}</div>
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>

    <!-- DISCLAIMER DIALOG -->
    <v-dialog
        v-model="showDisclaimerDialog"
        max-width="600"
        scrollable
    >
      <v-card
          class="rounded-lg d-flex flex-column"
      >
        <v-card-title></v-card-title>
        <v-card-text class="fill-height">
          <div v-html="$t('weFitter.bioAgeDisclaimer')">
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end mt-auto">
          <v-btn
              color="primary"
              depressed
              class="rounded-lg"
              @click.prevent="showDisclaimerDialog = false"
          >
            {{ $t('buttons.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from "@/api/api";

export default {
  name: "mth-bio-age-widget",
  data() {
    return {
      isLoading: false,
      profile: {},
      bioAgeList: [],
      bioAgeValues: [],
      bioAgeLabels: [],
      dailySummary: [],
      realAge: 1,
      showDisclaimerDialog: false,
      connectionWefitterLoading: false,
      connectionWefitter: {}
    }
  },

  mounted(){
    this.fetchConnectionWefitter()
    // this.fetchProfileAndBioAge()
  },

  methods: {
    async fetchConnectionWefitter() {
      const that = this
      that.connectionWefitterLoading = true
      await api.connections.getWefitterStatus()
          .then((res) => {
            that.connectionWefitter = res.data
          })
      
      if (this.connectionWefitter.wefitterBioAgeConnected) {
        await this.fetchProfileAndBioAge()
      } else {
        this.isLoading = false
      }
      that.connectionWefitterLoading = false
    },
    async fetchProfileAndBioAge() {
      this.isLoading = false
      const that = this
      await api.account.getProfile()
          .then((res) => {
            that.profile = res.data
          })
      //await api.connections.activateBioAge()
      await this.fetchBioAgeList()
      await this.fetchDailySummary()
      this.isLoading = false
    },

    async fetchBioAgeList() {
      let storage = localStorage.getItem(this.profile.identifier + '.bio_age')
      if (storage) { storage = JSON.parse(storage)}
      if (!storage || this.$moment(storage.timestamp).isBefore(this.$moment().subtract(4, 'hours'))){
        let profile = await api.connections.getWefitterProfile().then((res) => { return res.data })
        if (!profile ||
            !profile.birthdate ||
            !profile.gender ||
            !['m', 'f', 'x'].includes(profile.gender.toLowerCase()) ||
            (this.profile.gender.toLowerCase() !== 'u' && this.profile.gender.toLowerCase() !== profile.gender.toLowerCase()) ||
            this.profile.birthDate !== profile.birthdate
        ){ await api.connections.activateBioAge() }
        await api.connections.getWefitterBioAgeList(this.$moment().subtract(56, 'days').format('YYYY-MM-DD'), this.$moment().format('YYYY-MM-DD'))
            .then((res) => {
              this.bioAgeList = res.data.sort((b, a) => { return this.$moment(a.end).unix() - this.$moment(b.end).unix() })
              let bioAgeStorage = { timestamp: this.$moment(), bioAgeList: this.bioAgeList}
              localStorage.setItem(this.profile.identifier + '.bio_age', JSON.stringify(bioAgeStorage))
            })
      } else {
        this.bioAgeList = storage.bioAgeList
      }
      this.realAge = this.$moment().diff(this.profile.birthDate, 'years')
    },

    async fetchDailySummary() {
      await api.connections.getWefitterDailySummary(this.$moment().format('YYYY-MM-DD'), this.$moment().format('YYYY-MM-DD'))
          .then((res) => {
            this.dailySummary = res.data
          })
    },
    
    navigate(route){
      this.$root.$emit('m2h-loader-show')
      window.location.href = route
    }
  }
}
</script>

<style scoped>

</style>
